<script>
import app from 'app';
export default {
  props: {
    closeModal: { type: Function },
    creditMaxTitle: { type: Number, default: 100 },
  },

  data() {
    return {
      model: {
        sharedWithTeam: true, // false - USER_PRIVATE, true - ORGANIZATION_PRIVATE
        orgId: null,
        keywords: [],
        attribution: '',
        attributionMode: false, // false - NONE, true - SHOW_IN_VIDEO
        autoTranscribe: false,
      },
    };
  },

  computed: {
    MAX_TITLE_LENGTH() {
      return app.MAX_TITLE_LENGTH;
    },

    MAX_TITLE_CREDIT_LENGTH() {
      // related to this issue:
      // https://wochit.atlassian.net/browse/DEV-7724
      // backend can't handle more then 100 chars
      return this.creditMaxTitle;
    },

    commonData() {
      return {
        orgId: this.model.sharedWithTeam
          ? localStorage.getItem('selectedOrganizationId')
          : null,
        privacy: this.model.sharedWithTeam
          ? app.privacyType.ORGANIZATION_PRIVATE
          : app.privacyType.USER_PRIVATE,
        keywords: this.model.keywords,
        attributionMode: this.model.attributionMode
          ? app.attributionType.SHOW_IN_VIDEO
          : app.attributionType.NONE,
        attribution: this.model.attribution,
        autoTranscribe: this.model.autoTranscribe,
      };
    },
  },

  mounted() {
    this.model.sharedWithTeam = true;
  },

  methods: {
    addKeyword(newTag) {
      if (newTag && newTag !== '') {
        this.model.keywords.push(newTag);
      }
    },

    removeKeyword(removeTag) {
      this.model.keywords = this.model.keywords.filter(
        (tag) => tag !== removeTag
      );
    },
  },
};
</script>
